module.exports = __webpack_public_path__ + "static/media/world-map.5527119c.svg";